export const styles = theme => ({
  container: {
    marginBottom: 30,
    padding:10,
    backgroundColor: theme.palette.lightyellow.color
  },
  infoIcon: {
    marginBottom: -6,
    color: theme.palette.yellow.color,
    [theme.direction === 'rtl' ? 'marginLeft' : 'marginRight']: 5,
  },
  subtitle: {
    display: 'inline',
  },
  text:{
    padding: '5px 0px 5px 35px',
    [theme.breakpoints.down('xs')]: {
      padding: '15px 0',
    }
  },
  controls:{
    padding: 10,
    textAlign: 'right' as const
  },
  link: {
    color: theme.palette.primary.main,
    padding: 10,
    fontSize: 16
  }
})
